"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientValueResolver = void 0;
/**
 * The resolver return the appropriate instance of a given {@link AmbientValue} class
 */
class AmbientValueResolver {
}
exports.AmbientValueResolver = AmbientValueResolver;
//# sourceMappingURL=AmbientValueResolver.js.map